module.exports = __webpack_public_path__ + "img/2-gray-cartoon.087418fe.png";